var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import color from "detail/utils/color";
import { useDispatch, useSelector } from 'react-redux';
import TopFiler from './top_filter';
import Item from './item';
import validation from "../../../utils/validation";
import GalleryComponent from "./galleryComponent";
import ScoreBox from "./score_box";
import { REVIEW_LIST_REQUEST } from "../../../reducers/review";
import Api2 from "../../../utils/api2";
import { layerAction, validationAction } from "../../../reducers/layer";
import PageCompoenent from "./page";
var testArr = [];
var testState = false;
if (testState) {
    dummyData();
}
//테스트용
function dummyData() {
    for (var i = 0; i <= 112; i++) {
        var testObj = {
            bbs_like: 2,
            bbs_notify_cnt: 0,
            cnt_hate: 0,
            cnt_img: 0,
            cnt_like: 0,
            cnt_rep: 0,
            comments: [],
            dt_reg: "2022-02-21 12:07:06",
            f_hidden: 0,
            f_key: 0,
            f_rep: 0,
            files: "",
            idx_member: 1950701,
            idx_threads: 57,
            ip: "172.***.0.1",
            mall_name: "",
            marks: 5,
            message: "삼성전자 DDR4-3200 (8GB) 상품평 테스트",
            my_bbs: 0,
            my_bbs_notify: 0,
            nm_nick: "테스트"
        };
        if (i === 0) {
            testObj.my_bbs = 1;
            testArr.push(testObj);
        }
        else if (i > 0) {
            testObj.idx_threads = 57 + i;
            testObj.nm_nick = testObj.nm_nick.concat(String(i));
            testObj.message = testObj.message.concat(String(i));
            testArr.push(testObj);
        }
    }
}
var Board = function (_a) {
    var reviewInfo = _a.reviewInfo, item_id = _a.item_id;
    var dispatch = useDispatch();
    var view = useSelector(function (state) { return state.review.view; });
    var viewLoaded = useSelector(function (state) { return state.review.viewLoaded; });
    var userInfo = useSelector(function (state) { return state.common.userInfo; });
    var idx_b_manager = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_idx;
    var userInfoLoaded = useSelector(function (state) { return state.common.userInfoLoaded; });
    var reviewFilter = useSelector(function (state) { return state.review.filter; });
    var loadingState = useSelector(function (state) { return state.review.setReviewLoadingState; });
    var list = (view === null || view === void 0 ? void 0 : view.threads) || [];
    var totalPage = (view === null || view === void 0 ? void 0 : view.lastPage) || 1;
    var topFilerState = (!validation.checkEmpty(list) && list.length > 1) ? true : false;
    var fetchReviewList = useCallback(function () {
        dispatch({
            type: REVIEW_LIST_REQUEST,
            payload: __assign({ item_id: item_id, idx_b_manager: idx_b_manager }, reviewFilter)
        });
    }, [userInfo, reviewFilter]);
    useEffect(function () {
        if (userInfoLoaded || viewLoaded) {
            fetchReviewList();
        }
    }, [reviewFilter, userInfoLoaded, viewLoaded]);
    var onClickRegist = function () {
        Api2.getUserInfo().then(function (res) {
            var _a, _b;
            if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.id) {
                if (!reviewInfo.isConfirmed) {
                    dispatch(validationAction({ name: 'validation', data: { message: '상품 구매확정 후 등록하실 수 있습니다.', btnTxt: '확인' } }));
                    return false;
                }
                if (!reviewInfo.ableWrite) {
                    dispatch(validationAction({ name: 'validation', data: { message: '더 이상 상품평을 등록할 수 없습니다.', btnTxt: '확인' } }));
                    return false;
                }
                dispatch(layerAction({ name: 'reviewRegist' }));
            }
            if (((_b = res.data) === null || _b === void 0 ? void 0 : _b.desc) === 'not_login') {
                dispatch(layerAction({ name: 'login' }));
            }
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(RegistButton, { className: "regist", onClick: onClickRegist }, "\uC0C1\uD488\uD3C9 \uB4F1\uB85D\uD558\uAE30"),
        React.createElement(ScoreBox, { item_id: item_id, view: view, reviewInfo: reviewInfo, selectedMark: reviewFilter === null || reviewFilter === void 0 ? void 0 : reviewFilter.marks }),
        React.createElement(Style, null,
            React.createElement(GalleryComponent, { item_id: item_id }),
            (list && (list === null || list === void 0 ? void 0 : list.length) > 0)
                ? (React.createElement(React.Fragment, null,
                    topFilerState && React.createElement(TopFiler, null),
                    React.createElement("div", null, list.map(function (v) { return (React.createElement(Item, { key: v.idx_threads, item_id: item_id, data: v, reviewInfo: reviewInfo })); })),
                    totalPage > 1 && React.createElement(PageCompoenent, { reviewFilter: reviewFilter, reviewTotal: view === null || view === void 0 ? void 0 : view.total })))
                : React.createElement(Nolist, null, "\uB4F1\uB85D\uB41C \uC0C1\uD488\uD3C9\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."))));
};
var RegistButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position:absolute;\n    top:90px;\n    right:0;\n    width: 180px;\n    height: 40px;\n    font-size: 16px;\n    color: #fff;\n    background: #418ded;\n    border: 0;\n    &:hover{\n        background: #2D7EE4;\n    }\n"], ["\n    position:absolute;\n    top:90px;\n    right:0;\n    width: 180px;\n    height: 40px;\n    font-size: 16px;\n    color: #fff;\n    background: #418ded;\n    border: 0;\n    &:hover{\n        background: #2D7EE4;\n    }\n"])));
var Style = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 40px 0 0;\n"], ["\n    margin: 40px 0 0;\n"])));
var Nolist = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 300px;\n    font-size: 18px;\n    background: ", ";\n    color: ", ";\n    border-bottom: 1px solid ", ";\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 300px;\n    font-size: 18px;\n    background: ", ";\n    color: ", ";\n    border-bottom: 1px solid ", ";\n"])), color.colorFFF, color.color777, color.colorCCC);
export default React.memo(Board);
var templateObject_1, templateObject_2, templateObject_3;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/review/board/index.tsx
// module id = 242
// module chunks = 0